import { STATIC_URL } from './services';

export function hideLabelInSearchForm(title: string) {
  return (_: any, type?: string) => {
    if (type === 'table') {
      return title;
    }
    return null;
  };
}

export function getResourceUrl(attachment: string) {
  if (!attachment) return '';
  return attachment.startsWith('http')
    ? attachment
    : `${STATIC_URL}${attachment}`;
}
